import React, { useContext } from "react";
import { BreadcrumbWidget } from "@usap/widgets";
import { LocalContext } from "../../helpers/useLocalContext";

export default function Breadcrumb(props) {
  const { dynamicApiData } = props;
  if (!dynamicApiData || !Object.keys(dynamicApiData).length) return "";
  const { localContext } = useContext(LocalContext);
  const { Link } = localContext;
  return <BreadcrumbWidget links={dynamicApiData} Link={Link} />;
}
